import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { getEditorUrl } from 'page-lib/utils/urls';
import MABPastExperiments from './MABPastExperiments';
import useContentId from '../../hooks/useContentId';
import { useTrackPageView } from '../../hooks/useTrackPageView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MabNoMabState = () => {
  const contentId = useContentId();
  return /*#__PURE__*/_jsx(EmptyState, {
    primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.personalization.mabNoMab.body"
      }), /*#__PURE__*/_jsx(Button, {
        href: `${getEditorUrl(contentId)}/test`,
        use: "primary",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.personalization.mabNoMab.button"
        })
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "automated-testing",
      width: 200
    }),
    secondaryContentWidth: 200,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabNoMab.title"
    })
  });
};
const PersonalizationResults = ({
  pastMabExperimentIds
}) => {
  useTrackPageView('personalization-results');
  if (pastMabExperimentIds.length === 0) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "PERSONALIZATION_RESULTS_NO_DATA_LOADED",
      children: /*#__PURE__*/_jsx(MabNoMabState, {})
    });
  }
  return /*#__PURE__*/_jsx(MABPastExperiments, {});
};
export default PersonalizationResults;